import { useEffect, useState } from 'react'
import { Button } from 'antd'
import { connect } from 'react-redux'
import Feather from '@sysunite/react-feather'
import { LoadingOutlined } from '@ant-design/icons'
import { setCurrentItem } from 'Actions/explore'
import './GraphConsole.scss'

const buildBitBlock = (mask) => {
  const classNames = (bit) => {
    if (mask & bit) {
      return `bit-${bit} bit-active`;
    } else {
      return `bit-${bit}`;
    }
  }
  return <div class="bitblock">
    <div className="bitrow">
      <div title="Literal" className={classNames(1)}></div>
      <div className={classNames(2)}></div>
      <div className={classNames(4)}></div>
      <div className={classNames(8)}></div>
    </div>
    <div className="bitrow">
      <div className={classNames(16)}></div>
      <div className={classNames(32)}></div>
      <div className={classNames(64)}></div>
      <div className={classNames(128)}></div>
    </div>
    <div className="bitrow">
      <div className={classNames(256)}></div>
      <div className={classNames(512)}></div>
      <div className={classNames(1024)}></div>
      <div className={classNames(2048)}></div>
    </div>
    <div className="bitrow">
      <div className={classNames(4096)}></div>
      <div className={classNames(8192)}></div>
      <div className={classNames(16384)}></div>
      <div className={classNames(32768)}></div>
    </div>
  </div>
}


const SparqlAnalyze = ({ height, width, query }) => {
  const [effectiveSparql, setEffectiveSparql] = useState('')
  const [effectiveSql, setEffectiveSql] = useState('')
  const [solutions, setSolutions] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    (async () => {
      if (query !== null) {
        setLoading(true)
        try {
          const res = await Weaver.getCoreManager().POST("sparqlAnalyse", {query, unparsed: true});
          const report = JSON.parse(res);
          setEffectiveSparql(report.effectiveSparql)
          setEffectiveSql(report.effectiveSql)
          setSolutions(report.solutions)
        } catch (e) {
          // todo: give feedback somehow
        }
        setLoading(false)
      }
    })()
  }, [query])

  return (
    <div
      className="sparql-analyze-container"
      style={{
        bottom: `${height}px`,
        width: `${width}px`,
      }}
    >
      {
        loading
        ?
        <div className="query-table-loader-container">
          <LoadingOutlined style={{ fontSize: 44 }} spin />
        </div>
        :
        <div>
          <div style={{width: '100%', display: 'flex'}}>
            <div style={{margin:10}}>
              <pre>{effectiveSparql}</pre>
              Copy SQL<Button
                onClick={async ()=>{
                  await navigator.clipboard.writeText(effectiveSql)
                }}
                type="link"
                icon={<Feather type='copy' />}
              />
            </div>
            <div style={{margin:10}}><table>
              <tbody>
                {Object.keys(solutions).map((alias)=>{
                  return Object.keys(solutions[alias]).map((binding)=>{
                    return <tr key={`${alias}-${binding}`}>
                      <td style={{padding: 4}}>{alias}</td>
                      <td style={{padding: 4}}><tt>{binding}</tt></td>
                      <td style={{padding: 4}}>{buildBitBlock(parseInt(solutions[alias][binding].type, 2))}</td>
                      <td style={{padding: 4}}>{solutions[alias][binding].headers.map((header)=><span style={{margin: 5}}>{header}</span>)}</td>
                    </tr>
                  })
                })}
              </tbody>
            </table>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default connect(
  undefined,
  { setCurrentItem }
)(SparqlAnalyze)
